export default "__VITE_ASSET__d026abbe__"